"use client"

import { PanelTopClose } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelTopCloseIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelTopCloseIcon = component(Icon)({ as: PanelTopClose })
